export default __webpack_public_path__ + "static/media/shieldsweep3.c11ba0c8.png";